import React from 'react';
import { Switch, Redirect, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Notifications from '../Features/Notifications';

import { AuthRouter } from '../containers/TheAuthLayout';
import { TheLayoutRouter } from '../containers/TheLayout';
import RouteWithSubRoutes from '../Shared/RouteWithSubRoutes';

import '../scss/style.scss';
import Preloader from '../Shared/Preloader';
import { connectInitiative } from '../Features/Auth/actions';
import { twoFactorStatusTypes } from './constants/auth';

const AppRouter = () => {
  const { user, twoFactorStatus, userIdForLinkNewInitiative } = useSelector(
    ({ auth }) => auth.auth,
  );
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const isAuthLocation = React.memo(() => location.pathname.includes('/auth'), [location]);

  React.useEffect(() => {
    if (twoFactorStatus === twoFactorStatusTypes.needTotpSetup) history.push('/settings-page');
    if (twoFactorStatus === twoFactorStatusTypes.needTotpVerification)
      history.push('/auth/verify/');
    // eslint-disable-next-line
  }, [history, twoFactorStatus]);

  React.useEffect(() => {
    if (userIdForLinkNewInitiative && !isAuthLocation) {
      dispatch(connectInitiative(userIdForLinkNewInitiative));
    }
  }, [userIdForLinkNewInitiative, dispatch, isAuthLocation]);

  if (userIdForLinkNewInitiative && !isAuthLocation) {
    return <Preloader staticLoader />;
  }

  const currentUrl = `${location.pathname}${location.search}${location.hash}`;
  const isDefaultRoute = location.pathname === '/' && !location.search && !location.hash;

  // Check if we already have a redirect parameter from backend
  const urlParams = new URLSearchParams(location.search);
  const redirectParam = urlParams.get('redirect');
  const existingRedirect = redirectParam ? decodeURIComponent(redirectParam) : null;
  const redirect = existingRedirect || currentUrl;

  const redirectTo = {
    pathname: '/auth/sign-in',
    search: isDefaultRoute ? '' : `?redirect=${encodeURIComponent(redirect)}`,
  };

  return (
    <>
      <Switch>
        {user && <RouteWithSubRoutes {...TheLayoutRouter} />}
        <RouteWithSubRoutes {...AuthRouter} />
        <Redirect to={redirectTo} />
      </Switch>
      <Notifications />
    </>
  );
};

export default AppRouter;
